/** Build the Firebase Authorization header for direct (non-orval) asset fetches. */
export const getFirebaseAuthHeaders = async (): Promise<Record<string, string>> => {
  const headers: Record<string, string> = {}
  try {
    const {auth} = await import('../../gui/auth/firebase')
    const user = auth.currentUser
    if (user) {
      const token = await user.getIdToken()
      headers['Authorization'] = `Bearer ${token}`
    }
  } catch {
    // Firebase not available (e.g. render micro-frontend) — proceed unauthenticated.
  }
  return headers
}
